export default "__VITE_ASSET__3d6e0abb__"